import { createAction, props } from '@ngrx/store';
import { News } from '../news.model';

const actionType = '[News]';
const createActionType = (type: string) => `${actionType} - ${type}`;

export const loadNews = createAction(createActionType('Load news'));

export const loadNewsSuccess = createAction(
  createActionType('Load news success'),
  props<{ news: News[] }>(),
);

export const loadNewsError = createAction(
  createActionType('Load news error'),
  props<{ error: string }>(),
);
